import { render, staticRenderFns } from "./knowledgePoint.vue?vue&type=template&id=7cf50c9c&scoped=true&"
import script from "./knowledgePoint.vue?vue&type=script&lang=js&"
export * from "./knowledgePoint.vue?vue&type=script&lang=js&"
import style0 from "./knowledgePoint.vue?vue&type=style&index=0&id=7cf50c9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf50c9c",
  null
  
)

export default component.exports